<template>
    <v-container fluid style="max-width:1700px">
        <v-row>
            <v-col cols="12"  class="d-flex flex-column">
                <v-card>
                    <div class="chart-title">
                        {{ $t('KsaResults')}}
                    </div>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete hide-details dense outlined :items="surveys" v-model="selectedSurveys" item-value="id" item-text="nameAr" :label="$t('Surveys')">
                                    <template v-slot:item="{ item }">
                                        {{ item.id }} -  {{ isArabicLanguage ? item.nameAr : item.nameEn }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete searchable dense hide-details
                                                multiple
                                                clearable
                                                outlined
                                                v-model="selectedMunicipalityItems"
                                                :items="municipalityItems"
                                                item-value="id"
                                                item-text="name"
                                                :label="$t('sharedWithMunicipality')">
                                    <template v-slot:prepend-item>
                                        <v-list-item @click="selectAllItems">
                                            <v-list-item-content>{{ $t('SelectAll') }}</v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <h4>{{ item.name }}</h4>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <v-chip small :key="item.id" close @click:close="removeItem(item.id)">
                                            {{ item.name }}
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col md="6" cols="12">
                                <!-- Filter by Year -->
                                <v-menu v-model="yearMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                                      :label="$t('Year')"
                                                      readonly
                                                      v-bind="attrs"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="yearPicker" :max="maxDate"
                                                   type="year" @click:year="selectYear($event)"></v-date-picker>
                                </v-menu>

                            </v-col>
                            <v-col md="6" cols="12">
                                <!-- Filter by Quarter (using Calendar) -->
                                <v-select hide-details v-model="selectedQuarter" clearable outlined dense
                                          :items="quarters"
                                          :label="$t('Quarter')"></v-select>
                            </v-col>
                            <v-col md="6" cols="12">
                                <v-select v-model="selectedIcon"
                                          :items="icons"
                                          item-value="id"
                                          :label="$t('QuestionIconType')"
                                          :item-text="language == 'ar' ? 'iconTypeNameAr' : 'iconTypeNameEn'"
                                          outlined dense clearable>
                                    <!-- Custom item rendering -->
                                    
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row v-for="q in filterquestions" :key="q.id">
                            <v-col>
                                <v-select dense v-model="q.selectedValue" clearable outlined :items="q.options" :label="q.title" item-text="name" item-value="id"></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn color="secondary" class="my-3 ms-3 float-end" @click="clear()" :loading="loading">
                                    {{$t('Clear') }}
                                </v-btn>
                                <v-btn color="primary" class="my-3 float-end" @click="loadDemographics" :loading="loading">
                                    {{$t('Apply') }}
                                </v-btn>

                            </v-col>
                        </v-row>
                        <v-card class="elevation-0">
                            <div class="chart-title">{{$t('Municipalities')}}</div>
                            <v-card-text>
                                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loading"></v-skeleton-loader>
                                <v-card-text v-if="!loading">
                                    <MunicipalitiesChart v-if="result.length>0" v-model="amanatData" @selectMunicipality="selectMunicipality" />
                                </v-card-text>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col v-for="q in filteredQuestions" :key="q.id" cols="12" :md="columSize(q.resultTypeId, q)"  class="d-flex flex-column">
                <!-- Educational Level Chart -->
                <template v-if="q.resultTypeId === ResultTypes.EducationalLevel">
                    
                    <v-skeleton-loader v-if="loadingeducationalLevel"
                                       type="list-item-avatar, divider, list-item-three-line, card-heading, image" />
                                       <v-card style="background-color: #efeded; height: 100%" v-if="!loadingeducationalLevel && q.educationalLevel">
                                           <v-card-text style="padding:0px">
                                               <div class="chart-title d-flex justify-space-between align-center mt-0">
                                                   {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                                                   <table style="margin:0px;height:43.2px">
                                                       <tr>

                                                           <td>{{questionIconName(q.iconTypeId)}}</td>
                                                           <td width="10"></td>
                                                           <td>
                                                               <span class="icon">
                                                                   <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                                               </span>
                                                           </td>
                                                       </tr>
                                                   </table>
                                                   
                                               </div>
                                           </v-card-text>
                                        <v-card-text>
                                       <EducationLevelChart v-model="q.educationalLevel" />
                                         </v-card-text>
                                         </v-card>
                </template>

                <!-- Age Group Chart -->
                <template v-else-if="q.resultTypeId === ResultTypes.AgeGroup">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader v-if="loadingageGroup"
                                       type="list-item-avatar, divider, list-item-three-line, card-heading, image" />
                    <AgeGroupChart v-model="q.ageGroup"
                                   v-if="!loadingageGroup && q.ageGroup" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Gender">
                    
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadinggenders"></v-skeleton-loader>
                    <v-card color="#efeded" v-if="!loadinggenders && q.genders" style="height: 100%;">
                        <v-card-text style="padding:0px">
                            <div class="chart-title d-flex justify-space-between align-center mt-0">
                                {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                                <table style="margin:0px;height:43.2px">
                                    <tr>

                                        <td>{{questionIconName(q.iconTypeId)}}</td>
                                        <td width="10"></td>
                                        <td>
                                            <span class="icon">
                                                <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                            </span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </v-card-text>
                        <v-card-text>
                            <GenderChart v-model="q.genders" />
                        </v-card-text>
                    </v-card>
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.TripleSatisfaction">
                    
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingtripleSatisfactionTable"></v-skeleton-loader>
                    <v-card color="#efeded" style="height:calc(100% - 48.6px)" v-if="!loadingtripleSatisfactionTable && q.tripleSatisfactionTable">
                        <v-card-text>
                            <SatisfactionThreeLevels v-model="q.tripleSatisfactionTable" />
                        </v-card-text>
                    </v-card>
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Endorsment">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingendorsmentResults"></v-skeleton-loader>

                    <v-card color="#efeded" style="height: 100%" v-if="!loadingendorsmentResults && q.endorsmentResults">
                        <v-card-text>
                            <EndorsmentChart v-model="q.endorsmentResults" />
                        </v-card-text>
                    </v-card>
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.PreCommunication">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingprecommunicationresults"></v-skeleton-loader>
                    <PreCommunicationChart v-model="q.precommunicationresults" v-if="!loadingprecommunicationresults && q.precommunicationresults" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Profession">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingprofessions"></v-skeleton-loader>
                    <ProfessionsChart v-model="q.professions" v-if="!loadingprofessions && q.professions" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.SignedQuestion">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsignedquestionanswers"></v-skeleton-loader>
                    <SignedQuestionChart v-model="q.signedquestionanswers" v-if="!loadingsignedquestionanswers && q.signedquestionanswers" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.CommunicationReason">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingcomreasons"></v-skeleton-loader>
                    <CommunicationReasonChart v-model="q.comreasons" v-if="!loadingcomreasons" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Filter">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsakaniproducts"></v-skeleton-loader>
                    <SakaniProductsChart v-model="q.sakaniproducts" v-if="!loadingsakaniproducts && q.sakaniproducts" />
                </template>
                <!-- This is the desired one for -->
                <template v-else-if="q.resultTypeId === ResultTypes.CSAT51">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionAllRecords"></v-skeleton-loader>
                    <SatisfactionFiveLevels v-if="!loadingsatisfactionAllRecords" v-model="q.satisfactionTable" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.CSAT5Amanat && (q.csatfivetwoTable && q.csatfivetwoTable.filter(x => x.count > 0).length > 0 || loadingcsatfivetwoTable)">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingcsatfivetwoTable"></v-skeleton-loader>
                    <SatisfactionFiveLevels v-if="!loadingcsatfivetwoTable" v-model="q.csatfivetwoTable" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Nationality">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingnationalities"></v-skeleton-loader>
                    <NationalityChart v-model="q.nationalities" v-if="!loadingnationalities"></NationalityChart>
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Publication">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingpublications"></v-skeleton-loader>
                    <PublicationChart v-model="q.publications" v-if="!loadingpublications" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.NPS">
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingnpsresults"></v-skeleton-loader>
                    <NPSChart :iconName="questionIconName(q.iconTypeId)" :icon="questionIcon(q.iconTypeId)" v-if="!loadingnpsresults && q.npsresults" v-model="q.npsresults" :scores="q.npsscale" :title="language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn" />
                </template>
                
            </v-col>

            <v-col v-for="q in filteredQuestions.filter(x=>x.resultTypeId == ResultTypes.CSAT5Amanat)" :key="q.id" cols="12" class="d-flex flex-column">
                <template v-if="q.resultTypeId === ResultTypes.CSAT5Amanat && (q.satisfactionData && q.satisfactionData.filter(z => z > 0).length > 0 || loadingsatisfactionData)">

                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionData"></v-skeleton-loader>
                    <v-card class="elevation-5 mt-4 rounded-lg" v-if="!loadingsatisfactionData" style="height:100%">
                        <SatisfactionChart :satisfactionLabels="q.satisfactionLabels" :satisfactionLogos="q.satisfactionLogos" :satisfactionData="q.satisfactionData" :title="language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn" />
                    </v-card>
                </template>
            </v-col>
            
            
            
            <v-col cols="12" v-if="resultregion.filter(x=>x.count>0).length>0 || loadingregion"  style="height:100%">
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingregion"></v-skeleton-loader>
                <RegionsChart v-if="!loadingregion" v-model="resultregion" />

            </v-col>

            <v-col cols="12" v-if="satisfactionTablePerQuestions.length>0 || loadingsatisfactionTablePerQuestions"  style="height:100%">
                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('SatisfactionPerQuestion') }}
                    <table style="margin:0px;height:43.2px">
                        <tr>

                            <td>{{questionIconName(2)}}</td>
                            <td width="10"></td>
                            <td>
                                <span class="icon">
                                    <v-icon color="white" size="40">{{ questionIcon(2) }}</v-icon>
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionTablePerQuestions"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingsatisfactionTablePerQuestions" v-model="satisfactionTablePerQuestions" />
            </v-col>

            
            <v-col cols="12" v-if="(satisfactionQuartersPercentages.length>0 && satisfactionQuartersPercentages.filter(z=>z>0).length>0) || loadingsatisfactionQuarters"  style="height:100%">
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionQuarters"></v-skeleton-loader>
                <SatisfactionQuartersChart :satisfactionQuartersLabels="satisfactionQuartersLabels" :availableYears="availableYears" :satisfactionQuartersPercentages="satisfactionQuartersPercentages" v-if="!loadingsatisfactionQuarters" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import AnalyticsService from '@/services/AnalyticsService'
    import StructuresService from '@/services/StructuresService'
    import SurveyService from '@/services/SurveyService'
    import { mapGetters } from 'vuex'
    import { AnalyticsTypes, ResultTypes } from '@/helpers/constants/enumerations.js'
    import SatisfactionChart from '@/components/controls/SatisfactionChart.vue'
    //import SatisfactionAllRecordsChart from '@/components/controls/SatisfactionAllRecordsChart.vue'
    import SatisfactionQuartersChart from '@/components/controls/SatisfactionQuartersChart.vue'
    import GenderChart from '@/components/charts/Gender.vue'
    import AgeGroupChart from '@/components/charts/AgeGroup.vue'
    import EducationLevelChart from '@/components/charts/EducationLevel.vue'
    import ProfessionsChart from '@/components/charts/Professions.vue'
    import SignedQuestionChart from '@/components/charts/SignedQuestion.vue'
    import SatisfactionFiveLevels from '@/components/charts/SatisfactionFiveLevels.vue'
    import SatisfactionThreeLevels from '@/components/charts/SatisfactionThreeLevels.vue'
    import PublicationChart from '@/components/charts/PublicationChart.vue'
    import CommunicationReasonChart from '@/components/charts/CommunicationReasonChart.vue'
    import PreCommunicationChart from '@/components/charts/PreCommunication.vue'
    import SatisfactionPerQuestionChart from '@/components/charts/SatisfactionPerQuestion.vue'
    import SakaniProductsChart from '@/components/charts/SakaniProducts.vue'
    import NPSChart from '@/components/charts/NPSChart.vue'
    import EndorsmentChart from '@/components/charts/EndorsmentChart.vue'
    import MunicipalitiesChart from '@/components/charts/MunicipalitiesBar.vue'
    import NationalityChart from '@/components/charts/Nationality.vue'
    import RegionsChart from '@/components/charts/Regions.vue'
    export default {
        components: {
            SatisfactionChart, /*SatisfactionAllRecordsChart,*/ SatisfactionQuartersChart, GenderChart, AgeGroupChart, EducationLevelChart, ProfessionsChart, SignedQuestionChart, SatisfactionFiveLevels, PublicationChart, CommunicationReasonChart, PreCommunicationChart, SatisfactionPerQuestionChart, SatisfactionThreeLevels, SakaniProductsChart, NPSChart, EndorsmentChart, MunicipalitiesChart, NationalityChart, RegionsChart
        },
        data() {
            return {
                selectedMunicipalityItems: [],
                municipalityItems: [],
                ResultTypes: ResultTypes,
                questions:[],
                surveys: [],
                selectedSurveys: 0,
                result: [],
                resultregion: [],
                genders: [],
                gendertitle:'',
                professions: [],
                professionstitle:'',
                maxStars: 5,
                nationalities: [],
                nationalitytitle:'',
                ageGroup: [],
                educationalLevel: [],
                educationalLeveltitle:'',
                publications: [],
                publicationstitle:'',
                loading: false,
                loadingregion: false,
                satisfactionLabels: [],
                satisfactiontitle:'',
                npsresults: [],
                npstitle:'',
                npsscale: [],
                satisfactionLogos: [],
                satisfactionData: [],
                amanatData:[],
                satisfactionTable: [],
                satisfactionTableTitle:'',
                csatfivetwoTable: [],
                csatfivetwoTableTitle:'',
                satisfactionTablePerQuestions: [],
                tripleSatisfactionTable: [],
                tripleSatisfactionTableTitle:'',
                signedquestionanswers: [],
                signedquestionName:'',
                precommunicationresults: [],
                precommunicationtitle:'',
                endorsmentResults: [],
                endorsmentTitle:'',
                comreasons: [],
                comreasonstitle:'',
                sakaniproducts: [],
                sakaniproductstitle:'',
                loadinggenders: false,
                loadingsignedquestionanswers: false,
                loadingprofessions: false,
                loadingnationalities: false,
                loadingageGroup: false,
                loadingeducationalLevel: false,
                loadingpublications: false,
                loadingsatisfactionData: false,
                loadingsatisfactionAllRecords: false,
                loadingsatisfactionQuarters: false,
                loadingcomreasons: false,
                loadingprecommunicationresults: false,
                loadingsatisfactionTablePerQuestions: false,
                loadingtripleSatisfactionTable: false,
                filterquestions: [],
                loadingsakaniproducts: false,
                loadingnpsresults: false,
                loadingendorsmentResults: false,
                loadingcsatfivetwoTable: false,
                agegrouptitle: '',
                icons: [],
                selectedIcon:null,
                data: [
                    { category: 'Task A', value: 10 },
                    { category: 'Task B', value: 35 },
                    { category: 'Task C', value: 65 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 3 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 13 },
                    { category: 'Task D', value: 5 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 25 },
                    { category: 'Task D', value: 75 },
                    { category: 'Task E', value: 42 }
                ],
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                yearPicker: null,
                maxDate: new Date().toISOString().split('T')[0],
                quarters: [{ value: 'q1', text: this.$t('QuarterOne') }, { value: 'q2', text: this.$t('QuarterTwo') }, { value: 'q3', text: this.$t('QuarterThree') }, { value: 'q4', text: this.$t('QuarterFour') }],
                satisfactionQuartersLabels: [],
                satisfactionQuartersPercentages: [],
                availableYears: []
            }
        },
        computed: {
            ...mapGetters('user', ['loggedInUser', 'language']),
            isArabicLanguage() {
                return this.language == 'ar'
            },
            questionIconName() {
                return (id) => {
                    var result = this.icons.filter(x => x.id == id)[0]

                    return result ? (this.language == 'ar' ? result.iconTypeNameAr : result.iconTypeNameEn) :''
                }
            },
            questionIcon() {
                return (id) => {
                    var result = this.icons.filter(x => x.id == id)[0]

                    return result ? result.icon : ''
                }
            },
            columSize() {
                return (resultTypeId, q)=>
                {
                    var col = '6'
                    switch (resultTypeId) {
                        case this.ResultTypes.EducationalLevel:
                        case this.ResultTypes.AgeGroup:
                        case this.ResultTypes.Gender:
                        case this.ResultTypes.Filter:
                        case this.ResultTypes.Nationality:
                        case this.ResultTypes.Publication:
                        case this.ResultTypes.Profession:
                        case this.ResultTypes.SignedQuestion:
                        case this.ResultTypes.CommunicationReason:
                        case this.ResultTypes.PreCommunication:
                        case this.ResultTypes.TripleSatisfaction:
                        case this.ResultTypes.Endorsment:
                        case this.ResultTypes.CSAT51:
                        case this.ResultTypes.NPS:
                            col = '6'
                            break
                        case this.ResultTypes.CSAT5Amanat:
                            col='6'
                            /*if ((q.csatfivetwoTable && q.csatfivetwoTable.filter(x => x.count > 0).length > 0))
                                col = '12'
                            else if ((q.satisfactionData && q.satisfactionData.filter(z => z > 0).length > 0))
                                col = '6'*/
                            
                            break
                        default:
                            col = '6'
                            break
                    }
                    return col
                }
            },
            filteredQuestions() {
                // Filter questions to only include those with the relevant resultTypeId
                return this.questions?this.questions.filter(
                    (q) =>
                        (q.resultTypeId === this.ResultTypes.EducationalLevel && ((q.educationalLevel && q.educationalLevel.filter(x => x.count > 0).length > 0) || this.loadingeducationalLevel)) ||
                        (q.resultTypeId === this.ResultTypes.AgeGroup && ((q.ageGroup && q.ageGroup.filter(x => x.count > 0).length > 0) || this.loadingageGroup)) ||
                        (q.resultTypeId === this.ResultTypes.Gender && ((q.genders && q.genders.filter(x => x.count > 0).length > 0) || this.loadinggenders)) ||
                        (q.resultTypeId == this.ResultTypes.Filter && ((q.sakaniproducts && q.sakaniproducts.filter(x => x.count > 0).length > 0) || this.loadingsakaniproducts)) ||
                        (q.resultTypeId === this.ResultTypes.Nationality && ((q.nationalities && q.nationalities.filter(x => x.count > 0).length > 0) || this.loadingnationalities)) ||
                        (q.resultTypeId === this.ResultTypes.Publication && ((q.publications && q.publications.length > 0) || this.loadingpublications)) ||
                        (q.resultTypeId === this.ResultTypes.Profession && ((q.professions && q.professions.filter(x => x.count > 0).length > 0) || this.loadingprofessions)) ||
                        (q.resultTypeId === this.ResultTypes.SignedQuestion && ((q.signedquestionanswers && q.signedquestionanswers.filter(x => x.count > 0).length > 0) || this.loadingsignedquestionanswers)) ||
                        (q.resultTypeId === this.ResultTypes.CommunicationReason && ((q.comreasons && q.comreasons.filter(x => x.count > 0).length > 0) || this.loadingcomreasons)) ||
                        (q.resultTypeId === this.ResultTypes.PreCommunication && ((q.precommunicationresults && q.precommunicationresults.filter(x => x.count > 0).length > 0) || this.loadingprecommunicationresults)) ||
                        (q.resultTypeId === this.ResultTypes.TripleSatisfaction && ((q.tripleSatisfactionTable && q.tripleSatisfactionTable.length > 0 && q.tripleSatisfactionTable.filter(x => x.count > 0 && x.percentage > 0).length > 0) || this.loadingtripleSatisfactionTable)) ||
                        (q.resultTypeId === this.ResultTypes.NPS && ((q.npsresults && q.npsresults.length > 0) || this.loadingnpsresults)) ||
                        (q.resultTypeId === this.ResultTypes.Endorsment && ((q.endorsmentResults && q.endorsmentResults.filter(x => x.count > 0).length > 0) || this.loadingendorsmentResults)) ||
                        (q.resultTypeId === this.ResultTypes.CSAT51 && ((q.satisfactionTable && q.satisfactionTable.filter(x => x.count > 0).length > 0) || this.loadingsatisfactionAllRecords)) ||
                        (q.resultTypeId === this.ResultTypes.CSAT5Amanat && (
                            ((q.satisfactionData && q.satisfactionData.filter(z => z > 0).length > 0) || this.loadingsatisfactionData) ||
                            (
                                (q.csatfivetwoTable && q.csatfivetwoTable.filter(x => x.count > 0).length > 0)
                                || this.loadingcsatfivetwoTable
                            )
                        ))
                ):[]
            },
        },

        created() {
            this.listMunicipalities()
            this.listSurveys()
            this.listFilterQuestions()
            this.listQuestionIcons()
        },

        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
            },
            /*getAveragePercentage(municipalityGroup) {
      const totalPercentage = municipalityGroup.reduce((sum, item) => sum + item.percentage, 0)
      return (totalPercentage / municipalityGroup.length).toFixed(2) // Calculate average percentage
    },*/

            computedRating(percentage) {
                return (percentage / 100) * this.maxStars
            },

            removeItem(id) {
                const index = this.selectedMunicipalityItems.indexOf(id)
                if (index !== -1) {
                    this.selectedMunicipalityItems.splice(index, 1)
                }
            },

            selectAllItems() {
                this.selectedMunicipalityItems = this.municipalityItems.map(item => item.id)
            },

            clear() {
                this.selectedMunicipalityItems = []
                this.selectedSurveys = 0
                this.selectedYear = null
                this.selectedQuarter = null
                this.selectedIcon = null
            },

            getBackgroundColor(value) {
                const opacity = this.getOpacity(value)
                return `rgba(153,192,114, ${opacity})`
            },
            getBackgroundColorIntishar(value) {
                const opacity = this.getOpacity(value)
                return `rgba(255,150,125, ${opacity})`
            },
            getTextColor(value) {
                return value > 50 ? '#fff' : '#000'
            },
            getOpacity(value) {
                return (value / 100).toFixed(2)
            },

            listMunicipalities() {
                StructuresService.listMunicipalities().then((res) => {
                    if (res.data) {
                        
                        this.municipalityItems = res.data.map(item => ({
                            id: item.municipalityID,
                            name: item.name
                        }))
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            async listQuestionIcons() {
                var result = await SurveyService.listQuestionIcons()
                this.icons = result.data
            },
            listSurveys() {
                SurveyService.listSurveys(true, AnalyticsTypes.Sakani).then((res) => {
                    if (res.data) {
                        this.surveys = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            async listFilterQuestions() {
                let selectedSurveys = this.selectedSurveys
                var resp = await SurveyService.listFilterQuestions(AnalyticsTypes.Sakani, selectedSurveys)
                this.filterquestions = resp.data
            },
            async listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.result = resp.data
                this.amanatData = []
                for (var i = 0; i < resp.data.length; i++) {
                    var x = resp.data[i]
                    this.amanatData.push({ value: x.count, label: x.municipalityName, percentage: x.percentage, logo:x.logo })
                }
                this.loading = false
            },
            async listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.resultregion = resp.data
                this.loadingregion = false
            },
            async listPublications(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listPublications(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.publications = resp.data.data
                question.publicationstitle = resp.data.questionName
                this.loadingpublications = false
            },
            async listCommunicationReasons(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listCommunicationReasons(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.comreasons = resp.data.data
                question.comreasonstitle = resp.data.questionName
                this.loadingcomreasons = false
            },
            async listGenders(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listGenders(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.genders = resp.data.results
                question.gendertitle = resp.data.questionName
                this.loadinggenders = false
            },
            async listNPSResults(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listNPSResults(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.npsresults = resp.data.data
                question.npsscale = resp.data.scale
                this.loadingnpsresults = false
                question.npstitle = resp.data.questionName
            },
            async listSignedQuestionAnswers(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSignedQuestionAnswers(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.signedquestionanswers = resp.data.data
                question.signedquestionName = resp.data.questionName
                this.loadingsignedquestionanswers = false
            },
            async listPrecommunication(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listPrecommunication(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.precommunicationresults = resp.data.data
                question.precommunicationtitle = resp.data.questionName
                this.loadingprecommunicationresults = false
            },
            async listProfessions(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listProfessions(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.professions = resp.data.data
                this.loadingprofessions = false
                question.professionstitle = resp.data.questionName
            },
            async listSakaniProducts(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniProducts(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.sakaniproducts = resp.data.data
                question.sakaniproductstitle = resp.data.questionName
                this.loadingsakaniproducts = false
            },
            async listEucationalLevels(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listEucationalLevels(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.educationalLevel = resp.data.data
                question.educationalLeveltitle = resp.data.questionName
                this.loadingeducationalLevel = false
            },
            async listNationalities(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listNationalities(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.nationalities = resp.data.data
                question.nationalitytitle = resp.data.questionName
                this.loadingnationalities = false
            },
            async listAgeGroup(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listAgeGroup(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.ageGroup = resp.data.data
                question.agegrouptitle = resp.data.questionName
                this.loadingageGroup = false
            },
            async listSakaniSatisfaction(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniSatisfaction(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.satisfactionLabels = []
                question.satisfactionLogos = []
                question.satisfactionData = []
                question.satisfactiontitle = resp.data.questionName
                for (var i = 0; i < resp.data.data.length; i++) {
                    var x = resp.data.data[i]
                    question.satisfactionLabels.push('')
                    question.satisfactionLogos.push(x.logo)
                    question.satisfactionData.push(x.percentage)
                }
                this.loadingsatisfactionData = false
            },
            async listSakaniSatisfactionPerQuestion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionPerQuestion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionTablePerQuestions = resp.data
                this.loadingsatisfactionTablePerQuestions = false
            },
            async listSakaniSatisfactionAllRecordsAsync(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniSatisfactionAllRecordsAsync(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.satisfactionTable = resp.data.data
                question.satisfactionTableTitle = resp.data.questionName
                this.loadingsatisfactionAllRecords = false
            },
            async listCSAT52(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listCSAT52(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.csatfivetwoTable = resp.data.data
                question.csatfivetwoTableTitle = resp.data.questionName
                this.loadingcsatfivetwoTable = false
            },
            async listSakaniTripleSatisfaction(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniTripleSatisfaction(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.tripleSatisfactionTable = resp.data.data
                question.tripleSatisfactionTableTitle = resp.data.questionName
                this.loadingtripleSatisfactionTable = false
            },
            async listEndorsmentResults(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listEndorsmentResults(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.endorsmentResults = resp.data.data
                question.endorsmentTitle = resp.data.questionName
                this.loadingendorsmentResults = false
            },
            async listSakaniSatisfactionQuarters(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionQuarters(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionQuartersLabels = []
                this.satisfactionQuartersPercentages = []
                this.availableYears = []
                var rows = resp.data
                rows.sort((a, b) => a.year - b.year)
                for (var i = 0; i < rows.length; i++) {
                    var x = rows[i]
                    var qlabel = this.quarters[x.quarter - 1].text + ' ' + x.year
                    this.satisfactionQuartersLabels.push(qlabel)
                    this.satisfactionQuartersPercentages.push(x.percentage)
                    this.availableYears.push(x.year)
                }
                this.loadingsatisfactionQuarters = false
            },
            async listAnalyticsQuestions(selectedSurveys) {
                var result = await SurveyService.listAnalyticsQuestions(selectedSurveys, AnalyticsTypes.Sakani, this.selectedIcon)
                this.questions = await result.data
            },
            selectMunicipality(municipality) {
                var found = this.municipalityItems.filter(x => x.name == municipality.label)
                if (found.length>0) {
                    var item = found[0]
                    this.selectedMunicipalityItems = []
                    this.selectedMunicipalityItems.push(item.id)
                    this.loadDemographics()
                }                
            },
            async loadDemographics() {
                if (this.selectedSurveys) {
                    let selectedSurveys = this.selectedSurveys
                    let selectedMunicipalities = this.selectedMunicipalityItems
                    this.loading = true
                    this.loadinggenders = true
                    this.loadingsignedquestionanswers = true
                    this.loadingprofessions = true
                    this.loadingnationalities = true
                    this.loadingageGroup = true
                    this.loadingpublications = true
                    this.loadingsatisfactionData = true
                    this.loadingsatisfactionAllRecords = true
                    this.loadingsatisfactionQuarters = true
                    this.loadingregion = true
                    this.loadingprecommunicationresults = true
                    this.loadingsatisfactionTablePerQuestions = true
                    this.loadingtripleSatisfactionTable = true
                    this.loadingsakaniproducts = true
                    this.loadingnpsresults = true
                    this.loadingendorsmentResults = true
                    this.loadingcsatfivetwoTable = true
                    await this.listAnalyticsQuestions(selectedSurveys)
                    this.filteredQuestions.map((q) => {

                        switch (q.resultTypeId) {
                            case ResultTypes.EducationalLevel:
                                this.listEucationalLevels(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.AgeGroup:
                                this.listAgeGroup(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.Gender:
                                this.listGenders(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.TripleSatisfaction:
                                this.listSakaniTripleSatisfaction(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.Endorsment:
                                this.listEndorsmentResults(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.PreCommunication:
                                this.listPrecommunication(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.Profession:
                                this.listProfessions(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.SignedQuestion:
                                this.listSignedQuestionAnswers(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.CommunicationReason:
                                this.listCommunicationReasons(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.Filter:
                                this.listSakaniProducts(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.CSAT51:
                                this.listSakaniSatisfactionAllRecordsAsync(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.CSAT5Amanat:
                                this.listCSAT52(selectedSurveys, selectedMunicipalities, q)
                                this.listSakaniSatisfaction(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.Nationality:
                                this.listNationalities(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.Publication:
                                this.listPublications(selectedSurveys, selectedMunicipalities, q)
                                break
                            case ResultTypes.NPS:
                                this.listNPSResults(selectedSurveys, selectedMunicipalities, q)
                                break
                        }
                    })
                    try {
                        
                        this.listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities)
                        this.listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities)                        
                        this.listSakaniSatisfactionQuarters(selectedSurveys, selectedMunicipalities)
                        this.listSakaniSatisfactionPerQuestion(selectedSurveys, selectedMunicipalities)
                        
                    }
                    catch (ex) {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        this.loading = false
                        this.loadinggenders = false
                        this.loadingsignedquestionanswers = true
                        this.loadingprofessions = false
                        this.loadingeducationalLevel = false
                        this.loadingnationalities = false
                        this.loadingageGroup = false
                        this.loadingpublications = false
                        this.loadingsatisfactionData = false
                        this.loadingsatisfactionAllRecords = false
                        this.loadingsatisfactionQuarters = false
                        this.loadingregion = false
                        this.loadingprecommunicationresults = false
                        this.loadingsatisfactionTablePerQuestions = false
                        this.loadingtripleSatisfactionTable = false
                        this.loadingsakaniproducts = false
                        this.loadingnpsresults = false
                        this.loadingendorsmentResults = false
                        this.loadingcsatfivetwoTable = false
                    }
                }
                else {
                    this.$root.$notification(this.$t('PleaseChooseSurvey'), 'error')
                }
            },
        },
    }
</script>

<style scoped>
    .ksa-bg {
        background: url(../assets/images/KSA.png) no-repeat center
    }

    .pink-color {
        color: #ff99cc !important
    }

    .amber-color {
        color: #bf9000 !important
    }

    .green-color {
        color: #6ba786 !important
    }
</style>